// extracted by mini-css-extract-plugin
export default {"datepicker":"DatePicker_datepicker__e2pa7","borderless":"DatePicker_borderless__craqh"};